import * as olSource from "ol/source";

function osm(): olSource.OSM {
  return new olSource.OSM();
}

export default osm;
